import {
  IFormTemplate,
  IServiceMethods
} from "../../interfaces/utils.interface";
import { ServiceManager } from "../../service-manager";
import { resetFormControls } from "../../helpers/function";
import { FormTemplateComponent } from "./form-template.component";
import { DismissReason } from "../../helpers/enums";
import { FormEventArgs } from "./form-utils";
import { BlockerManager } from "../../helpers/modal-option";
import { appInjector } from "../../helpers/app-injector";
import { ModalFormRef, FormLevel } from "./modal-form.service";
import { OnDestroy, AfterViewInit, ViewChild, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import { Subscription } from "rxjs/internal/Subscription";
import { ConfigService } from "../../services/config.service";
import { ActivatedRoute, Router } from "@angular/router";
import { MessageService } from "primeng/api";
import { ComponentManager } from "../../component-manager";

export class SingleForm implements OnDestroy, AfterViewInit {
  @ViewChild(FormTemplateComponent) formTemplate: FormTemplateComponent;

  protected _suscriptions: Subscription[] = [];

  modalFormRef: ModalFormRef;
  formLevel: FormLevel;
  blocker: BlockerManager;

  constructor() {
    this.formLevel = new FormLevel();
    this.blocker = new BlockerManager(appInjector().get(ConfigService));
  }

  setOptions(options: IFormTemplate) {
    Object.assign(this.formTemplate, options);
  }

  ngAfterViewInit() {
    if (this.formTemplate) {
      //para poner el foco cuando carge el form
      setTimeout(() => {
        this.formTemplate.focusControl.focus();
      }, 10);

      this._suscriptions.push(
        this.formTemplate.onActionChange.subscribe((args: FormEventArgs) => {
          switch (args.sender) {
            case DismissReason.Ok:
              this.dismissOk(args.event);
              break;
            case DismissReason.Cancel:
              this.dismissCancel(args.event);
              break;
          }
        })
      );
    }
  }

  ngOnDestroy() {
    this._suscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });

    this._suscriptions = [];
  }

  dismissCancel(event: string) {
    if (event === "keyboard" && !this.formLevel.isTopLevel()) {
      return;
    }

    if (this.modalFormRef) {
      this.modalFormRef.hide();

      if (this.modalFormRef.hiddenCallback) {
        this.modalFormRef.hiddenCallback({
          action: DismissReason.Cancel
        });
      }
    }
  }

  dismissOk(event: string) {
    if (event === "keyboard" && !this.formLevel.isTopLevel()) {
      return;
    }

    if (this.modalFormRef) {
      this.modalFormRef.hide();

      if (this.modalFormRef.hiddenCallback) {
        this.modalFormRef.hiddenCallback({
          action: DismissReason.Ok
        });
      }
    }
  }

  objectToWatchChanged(event: any) {
    this.formTemplate.form.form.markAsDirty();
  }

  get form(): NgForm {
    return this.formTemplate.form;
  }
}

export class FormManager extends SingleForm
  implements IServiceMethods, OnDestroy, AfterViewInit, OnInit {
  private _hasComponentManager = true;

  route = appInjector().get(ActivatedRoute);
  router = appInjector().get(Router);
  toastr = appInjector().get(MessageService);
  refreshCacheDataIfNotOwner = true;

  /*hasComponentManager: */
  get hasComponentManager(): boolean {
    return this._hasComponentManager;
  }

  set hasComponentManager(value: boolean) {
    this._hasComponentManager = value;

    if (!this._hasComponentManager) {
      this.formTemplate.showOkAndNew = false;

      if (!this.serviceManager.hasSubscriptions()) {
        this.serviceManager.subscribe();
      }
    } else {
      this._suscriptions.push(
        this.serviceManager.addedEmitter.subscribe(args => this.onAdded(args))
      );
    }

    if (
      this.serviceManager.cacheData &&
      this.serviceManager.cacheData.refresh &&
      this.refreshCacheDataIfNotOwner &&
      !this._hasComponentManager
    ) {
      this.serviceManager.cacheData.refresh();
    }
  }

  constructor(public serviceManager: ServiceManager<any>) {
    super();
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  ngOnInit() {
    this.serviceManager.callerComponent.state = "initializing";
    /*
    si callerComponent no esta definido entonces la llamada de este metodo fue hecha
    de manera interna, entoces se asume que el modelo no ha sido cargado aun y los datos que
    este contenga solo son los generados por el defaultModel.
    */
    const host = this.serviceManager.callerComponent.host;

    this.serviceManager.callerComponent.host = "form";

    if (host == "list") {
      this.formInit();
      return;
    }

    this._suscriptions.push(
      this.route.queryParams.subscribe(params => {
        const identity = params["id"];

        if (identity && !this.serviceManager.componentManager.modalMode) {
          const requeryOnEditState = this.serviceManager.requeryOnEdit;
          //esta parte del codigo se ejecutarÃ¡ solo cuando el requery que esta dentro del edit
          //termine
          this._suscriptions.push(
            this.serviceManager.requeryCompleteEmitter.subscribe(model => {
              this.serviceManager.requeryOnEdit = requeryOnEditState;
              this.formInit();
            })
          );

          this.serviceManager.identityValue = identity;
          this.serviceManager.requeryOnEdit = true;
          this.serviceManager.edit(this.serviceManager.current);
        } else {
          this.formInit();
        }
      })
    );
  }

  ngOnDestroy() {
    this.serviceManager.callerComponent.state = "destroying";
    super.ngOnDestroy();
  }

  formInit() {}

  dismissOk(event: string) {
    if (event === "keyboard" && !this.formLevel.isTopLevel()) {
      return;
    }

    this.serviceManager.post();
  }

  dismissCancel(event: string) {
    if (event === "keyboard" && !this.formLevel.isTopLevel()) {
      return;
    }

    this.serviceManager.cancel();
  }

  /*para poder encapsular el servicio */
  // add(model?: any) {
  // 	this.serviceManager.add(model);
  // 	return this;
  // }

  /*
		IServiceMethods:
		Solo aqui si no es invocado desde un component manager
  */
  onLoad(args?: any) {}

  onModal(args: any) {}

  onAdd(args?: any) {}

  onAdded(args?: any) {
    if (this.serviceManager.saveAndNew && this.hasComponentManager) {
      if (this.formTemplate.form) {
        resetFormControls(this.formTemplate.form);
      }

      this.formTemplate.focusControl.focus();
    } else {
      //se ejecuta cuando no tiene component manager
      if (this.modalFormRef) {
        this.modalFormRef.hide();
      }
    }
  }

  onEdit(args?: any) {}

  onEdited(args?: any) {
    if (this.modalFormRef) {
      this.modalFormRef.hide();
    }
  }

  onDelete(args: any) {}

  onDeleted(args: any) {}

  onStateChange(state?: any) {}

  onSettingRefreshed(args?: any) {}

  onCancel(event: string) {
    if (this.modalFormRef) {
      this.modalFormRef.hide();
    }
  }

  get componentManager(): ComponentManager<any> {
    return this.serviceManager.componentManager;
  }
}
